import { useState } from "react";

export default function NewsletterSection() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypotValue = (formData.get("website_alt") as string || "").trim();
    if (honeypotValue) {
      setStatus("success");
      setMessage("订阅成功！感谢你的关注。");
      setEmail("");
      return;
    }

    setStatus("loading");
    setMessage("");

    try {
      const payload = new FormData();
      payload.append("email", email);

      const response = await fetch("https://readdy.ai/api/form/d9q54sue3oq4jqumtgj0", {
        method: "POST",
        body: new URLSearchParams({ email }).toString(),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === "OK") {
        setStatus("success");
        setMessage("订阅成功！感谢你的关注。");
        setEmail("");
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || "订阅失败，请稍后再试";
        if (serverMsg.includes("spam") || serverMsg.includes("form data is spam")) {
          setStatus("error");
          setMessage("订阅失败，请稍后再试");
        } else {
          setStatus("error");
          setMessage(serverMsg);
        }
      }
    } catch {
      setStatus("error");
      setMessage("网络错误，请检查网络后重试");
    }
  };

  return (
    <section className="py-12 md:py-16 bg-primary-500">
      <div className="px-4 md:px-6 max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-3">
          订阅世界杯票务资讯
        </h2>
        <p className="text-background-50/80 text-sm mb-8">
          第一时间获取最新售票公告、抢票提醒和独家攻略，不错过任何购票机会
        </p>

        <form
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          data-readdy-form=""
        >
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入你的邮箱地址"
            required
            className="flex-1 px-4 py-3 rounded-full text-sm bg-background-50 text-foreground-900 placeholder:text-foreground-400 border-0 outline-none focus:ring-2 focus:ring-background-50/50"
          />
          <button
            type="submit"
            disabled={status === "loading"}
            className="px-6 py-3 bg-foreground-950 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-900 transition-colors duration-200 whitespace-nowrap cursor-pointer disabled:opacity-60"
          >
            {status === "loading" ? "订阅中..." : "立即订阅"}
          </button>

          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="absolute opacity-0 pointer-events-none"
            style={{ position: "absolute", left: "-9999px", top: "-9999px" }}
          />
        </form>

        {message && (
          <p
            className={`mt-4 text-sm ${
              status === "success" ? "text-background-50" : "text-background-50/80"
            }`}
          >
            {message}
          </p>
        )}

        <p className="mt-4 text-xs text-background-50/60">
          我们重视你的隐私，不会向第三方分享你的邮箱
        </p>
      </div>
    </section>
  );
}